import { ROP } from '../types';
export default {
  type: ROP,
  service: 'myetherwallet.com',
  url: 'https://api.myetherwallet.com/rop',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
